// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2NZlg","containerItemsCenter":"Skeleton_containerItemsCenter__181T4"};